import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0; // Ensures page loads at the top
    document.body.scrollTop = 0;
  }, [pathname]); // Runs every time the route changes

  return null;
};

export default ScrollToTop;